// Lib Imports
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Box, Heading } from 'grommet';

// CORE Imports
import EventEmitter from 'granite-admin/utils/event-emitter';
import { useToast } from 'granite-admin/core/components/Toast';
import SplitLayout from 'granite-admin/core/components/SplitLayout';

// Application Imports
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import { otpSubmit } from 'granite-admin/accounts/controllers/user';
import OtpVerificationForm from './components/OtpVerificationForm';
const type = process.env.REACT_APP_REGISTER_TYPE || 'email';
const OtpSubmit = ({
  location
}) => {
  const {
    successToast,
    errorToast
  } = useToast();
  const eventEmitter = useMemo(() => new EventEmitter(), []);
  const history = useHistory();
  useEffect(function init() {
    const observable = eventEmitter.getObservable();
    listenObservable();
    function listenObservable() {
      observable.subscribe(event => {
        switch (event.type) {
          case 'OTP_SUCCESS':
            successToast('Verification Successful');
            history.push('/dashboard');
            break;
          case 'OTP_FAILURE':
            errorToast('Please enter the correct OTP');
            break;
          default:
        }
      });
    }
  }, [eventEmitter, history, successToast, errorToast]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SplitLayout, {
    mainContent: /*#__PURE__*/React.createElement(Box, {
      width: "large",
      flex: "grow"
    }, /*#__PURE__*/React.createElement(Heading, {
      level: 3
    }, "Two Factor Login Verification"), /*#__PURE__*/React.createElement(Heading, {
      level: 5,
      size: "large",
      color: "dark-2"
    }, "Enter the One Time Password (OTP) sent on your registered", ' ', type === 'email' ? 'email address' : 'phone number', "."), /*#__PURE__*/React.createElement(OtpVerificationForm, {
      otpSubmit: otpSubmit,
      eventEmitter: eventEmitter,
      type: type,
      location: location
    }))
  }));
};
OtpSubmit.propTypes = {
  location: PropTypes.object
};
const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(OtpSubmit);